// this file is generated from the root of the admin repo
// see https://github.com/tocktix/admin/wiki/Svg-Icons-Components in order to add a new file;
import * as React from "react";
import SvgIcon, { SvgIconProps } from "@material-ui/core/SvgIcon";

export const SvgIconTicket = (props: SvgIconProps) =>
  React.createElement(
    SvgIcon,
    { width: "1em", height: "1em", viewBox: "0 0 24 24", ...props },
    <path d="M13.176 10.382L12 8l-1.176 2.382-2.628.382 1.902 1.854-.45 2.618L12 14l2.351 1.236-.449-2.618 1.902-1.854z" />,
    <path
      fillRule="evenodd"
      d="M2 5v5a2 2 0 110 4v5h20v-5a2 2 0 110-4V5zm4 7c0-1.48-.804-2.773-2-3.465V7h16v1.535A4 4 0 0018 12c0 1.48.804 2.773 2 3.465V17H4v-1.535A4 4 0 006 12"
    />
  );
export default SvgIconTicket;
